import { render, staticRenderFns } from "./create-profile.component.html?vue&type=template&id=0c1d0689&scoped=true&"
import script from "./create-profile.component.ts?vue&type=script&lang=ts&"
export * from "./create-profile.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-profile.component.scss?vue&type=style&index=0&id=0c1d0689&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d0689",
  null
  
)

export default component.exports